import { updateProjectAllDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateProjectAllCallable = getCallable(updateProjectAllDefinition);
